import React, { useState, useEffect, useRef, useContext } from "react";
import Simulation from "./../components/simulation";
import Grid from "./../components/grid";
import Intro from "./../components/intro";
import Filter, { FilterValue, ViewState } from "./../components/filter";
import Context from "../context";
import LocationContext from './../context/location';
import Footer from "../components/footer";
import { motion } from 'framer-motion';
import {Helmet} from "react-helmet";


const Home = ({gridView, introAnimationComplete, showHeader, setHeaderState}) => {
  const [ view, setView ] = useState(gridView);
  const [ filter, setFilter ] = useState(FilterValue.NONE);
  const [ showGrid, setShowGrid ] = useState(true);
	const [ holeWidth, setHoleWidth ] = useState(0)
  const animationStates = {
    stop: {
			value: false,
			text: 'stop'
		},
    start: {
			value: false,
			text: 'start'
		},
    continue: {
			value: false,
			text: 'continue'
		},
    complete: {
			value: false,
			text: 'complete'
		},
  };
	const [ currentAnimationState, setCurrentAnimationState ] = useState(null)
	const wrapperRef = useRef(null);
	const locationContext = useContext(LocationContext)

	useEffect(() => {
		setHeaderState({
			buttons: true,
			closeLink: false,
			aboutUsLink: true
		})
  }, []);

  const updateFilter = (value) => {
    setFilter(value);
  };

  const updateView = (value) => {
		locationContext.onSetGridView(value)
    setView(value);
  };

  const triggerGridAnimation = (value) => {
		setCurrentAnimationState(animationStates[value].text)
  };

	useEffect(() => {
		if (currentAnimationState === 'complete') {
			locationContext.onIntroAnimationComplete(true)
			showHeader()
			window.scroll(0,0)
		}
	}, [currentAnimationState])

	useEffect(() => {
		return (() => {
			locationContext.onIntroAnimationComplete(true)
			setShowGrid(false)
		})
	}, [])

	const PageTransition = {
		in: {
			opacity: 1,
			transition: {duration: 0.5, type: 'Tween'}
		},
		exit: {
			opacity: 0,
			transition: {duration: 0.3, type: 'Tween'}
		}
	}

  return (
    <motion.div initial="exit" animate="in" exit="exit" variants={PageTransition} ref={wrapperRef}>
			<Helmet>
				<title>BWS Jahresbericht 2020</title>
			</Helmet>
      <Context.Provider value={{ currentAnimationState: currentAnimationState, onTriggerGridAnimation: triggerGridAnimation }}>
        {!introAnimationComplete && <Intro holeWidth={holeWidth} />}
        {showGrid && view === ViewState.GRID ? (
          <Grid filter={filter} introAnimationComplete={introAnimationComplete} onSetHoleWidth={(value) => setHoleWidth(value)}/>
        ) : (
          showGrid && <Simulation filter={filter} />
        )}
        {introAnimationComplete && (
					<>
						{ showGrid && view === ViewState.GRID && <Footer /> }
						<Filter
							updateFilter={updateFilter}
							filter={filter}
							view={view}
							updateView={updateView}
						/>
					</>
        )}
    	</Context.Provider>
    </motion.div>
  );
};

export default Home;
